import { Button, Center, Image, Modal, ModalBody, ModalContent, ModalOverlay, Text } from '@chakra-ui/react';
import React from 'react';

function ModalSuporte(props) {
  const disclosure = props.disclosure;
  return (
    <>
      <Modal isOpen={disclosure.isOpen} onClose={disclosure.onClose} isCentered>
        <ModalOverlay />
        <ModalContent m={'11%'} borderRadius="0.8em">
          <ModalBody>
            {/* Removido Center vazio para evitar espaço extra ao final do modal */}
            <Center>
              <Text fontSize={'16px'} fontWeight={'bold'} color={'#333333'}>
                Suporte técnico DeoVita
              </Text>
            </Center>
            <Center>
              <Text fontSize={'14px'} mt={'1em'} textAlign={'justify'} letterSpacing={'-0.1em'}>
                Ao clicar em continuar, você será redirecionado para o nosso chat WhatsApp. Deseja continuar?
              </Text>
            </Center>
            <Center mt={'1em'}>
              <Button
                bg={'white'}
                border={'1px solid #666666'}
                color={'#666666'}
                borderRadius={'0.8em'}
                onClick={() => {
                  disclosure.onClose();
                }}
              >
                Cancelar
              </Button>
              <Button
                bg={'#5AB2AE'}
                ml={'1em'}
                color={'white'}
                borderRadius={'0.8em'}
                onClick={() => {
                  /*window?.ReactNativeWebView?.postMessage(
                    JSON.stringify({
                      service: true,
                      openInBrowser: true,
                      url: 'https://wa.me/5508002802133',
                    })
                  );*/
                  window?.open('https://wa.me/5508002802133', '_blank');
                }}
              >
                Continuar
              </Button>
            </Center>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
}

export default ModalSuporte;
